module.exports = __webpack_public_path__ + "media/images/hanamaro_horizon-719c6ee3b785faa424fc32d5c9839320.svg";